import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=2112e968&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=2112e968&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2112e968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2112e968')) {
      api.createRecord('2112e968', component.options)
    } else {
      api.reload('2112e968', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=2112e968&scoped=true&", function () {
      api.rerender('2112e968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pk6z5v8ENg7O/JS/comp/Paginate.vue"
export default component.exports